import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { DEFAULT_LANG } from '@/helpers/constant'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.name !== from.name) {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const currentLang = store.state.currentLang

  if (currentLang === DEFAULT_LANG) {
    next()
    return
  }
  if (to.query.lang !== currentLang) {
    next({
      path: to.path,
      query: { ...to.query, lang: currentLang },
      hash: to.hash,
      params: to.params
    })
  } else {
    next()
  }
})

export default router
